var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, query } from "lit/decorators.js";
import { html, LitElement } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { KVViewComponent } from "../kv-view/kv-view.js";
import releaseCss from "./release.css.js";
import sharedCss from "../../css/shared.css.js";
let ReleaseComponent = class ReleaseComponent extends LitElement {
    constructor() {
        super();
    }
    open() {
        if (this.details != null) {
            this.details.show().then(() => {
                window.scrollTo({
                    behavior: 'smooth',
                    top: this.details.getBoundingClientRect().top -
                        document.body.getBoundingClientRect().top -
                        150,
                });
            });
        }
    }
    render() {
        const kv = new Map();
        if (this.link) {
            kv.set('Release ', `<a href="${this.link}">${this.link}</a>`);
        }
        if (this.tarball) {
            kv.set('Tarball', `<a href="${this.tarball}">${this.tarball}</a>`);
        }
        const kvView = new KVViewComponent();
        kvView.data = kv;
        kvView.keyLabel = "";
        kvView.valueLabel = "";
        return html `
            <sl-details>
                <span class="summary ${this.milestone ? 'milestone' : ''} ${this.latest ? 'latest' : ''}" slot="summary">
                    ${this.name}<slot name="name"></slot> 
                    ${this.latest ? '(latest)' : ''}
                </span>
                <hr/>
                <p class="published">Published: ${this.published}
                    <slot name="published"></slot>
                </p>
                ${unsafeHTML(this.body.toString())}
                <slot></slot>
                <hr/>
                ${kvView}
            </sl-details>
        `;
    }
};
ReleaseComponent.styles = [sharedCss, releaseCss];
__decorate([
    property()
], ReleaseComponent.prototype, "name", void 0);
__decorate([
    property()
], ReleaseComponent.prototype, "body", void 0);
__decorate([
    property()
], ReleaseComponent.prototype, "published", void 0);
__decorate([
    property()
], ReleaseComponent.prototype, "link", void 0);
__decorate([
    property()
], ReleaseComponent.prototype, "author", void 0);
__decorate([
    property()
], ReleaseComponent.prototype, "authorLink", void 0);
__decorate([
    property()
], ReleaseComponent.prototype, "authorImage", void 0);
__decorate([
    property()
], ReleaseComponent.prototype, "tarball", void 0);
__decorate([
    property({ type: Boolean })
], ReleaseComponent.prototype, "milestone", void 0);
__decorate([
    property({ type: Boolean })
], ReleaseComponent.prototype, "latest", void 0);
__decorate([
    query('sl-details')
], ReleaseComponent.prototype, "details", void 0);
ReleaseComponent = __decorate([
    customElement('pb33f-release')
], ReleaseComponent);
export { ReleaseComponent };
